"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = __importStar(require("react"));
const i18n_1 = __importDefault(require("@yandex-int/pythia-libs/lib/i18n"));
const click_1 = require("src/hooks/click");
const types_1 = require("../types");
const attachment_video_1 = __importDefault(require("../attachment-video"));
const curtain_1 = __importDefault(require("../curtain"));
const utils_1 = require("../utils");
/* interface AttachmentVideoWithTimerProps extends StatusProps {
    value: VideoAttachment;
    timeLimit: number;
    timeLimitType: TimeLimitType;
} */
// eslint-disable-next-line max-statements
const AttachmentVideoWithTimer = props => {
    const i18n = (0, i18n_1.default)(['attach', 'video']);
    const curtainVideoDesc = {
        [types_1.TimeLimitType.NOT_MORE]: i18n(['notMore']),
        [types_1.TimeLimitType.NOT_LESS]: i18n(['notLess']),
        [types_1.TimeLimitType.WAIT_VIDEO_END]: i18n(['waitEnd'])
    };
    const { value: attachment, timeLimit, timeLimitType, status, handleStatus, collapseView } = props;
    const { service, extraParams } = attachment;
    const videoExtraParams = service === 'youtube' ? '?enablejsapi=1&controls=0&disablekb=1' : extraParams;
    const text = (0, utils_1.buildSecondsTpl)(curtainVideoDesc[timeLimitType], timeLimit, 'ro');
    const attachmentRef = (0, react_1.useRef)();
    const playerRef = (0, react_1.useRef)();
    const timeoutRef = (0, react_1.useRef)();
    const destroyPlayer = (0, react_1.useCallback)(() => {
        var _a;
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        (_a = playerRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
        handleStatus(types_1.AttachmentStatus.End);
        collapseView();
    }, [handleStatus, collapseView]);
    const handleCurtainClick = (0, click_1.useVideoCurtainClickHandler)({
        status,
        service,
        handleStatus,
        playerRef
    });
    const onStateChange = (0, react_1.useCallback)(
    // eslint-disable-next-line complexity
    e => {
        if (e.data === 0) {
            if (timeLimitType === types_1.TimeLimitType.NOT_MORE) {
                destroyPlayer();
            }
            else {
                handleStatus(types_1.AttachmentStatus.End);
            }
        }
        else if (e.data === 1 && status === types_1.AttachmentStatus.Initial) {
            handleStatus(types_1.AttachmentStatus.Playing);
        }
    }, [timeLimitType, status, destroyPlayer, handleStatus]);
    (0, react_1.useEffect)(() => {
        const playerConstructor = (0, utils_1.getVideoPlayerConstructor)(service);
        playerRef.current = playerConstructor(attachmentRef.current);
    }, [service, attachmentRef]);
    (0, react_1.useEffect)(() => {
        const stateChangeEvent = (0, utils_1.getChangeEventName)(service);
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        playerRef.current.on(stateChangeEvent, onStateChange);
    }, [playerRef, onStateChange, service]);
    // eslint-disable-next-line complexity
    (0, react_1.useEffect)(() => {
        if (!timeoutRef.current && status === types_1.AttachmentStatus.Playing) {
            if (timeLimitType === types_1.TimeLimitType.NOT_MORE) {
                // @ts-expect-error TS(2322): Type 'Timeout' is not assignable to type 'undefine... Remove this comment to see the full error message
                timeoutRef.current = setTimeout(() => {
                    destroyPlayer();
                }, timeLimit * 1000);
            }
            else if (timeLimitType === types_1.TimeLimitType.NOT_LESS) {
                // @ts-expect-error TS(2322): Type 'Timeout' is not assignable to type 'undefine... Remove this comment to see the full error message
                timeoutRef.current = setTimeout(() => {
                    handleStatus(types_1.AttachmentStatus.End);
                }, timeLimit * 1000);
            }
        }
        else if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        return () => clearTimeout(timeoutRef.current);
    }, [status, timeoutRef, timeLimit, destroyPlayer, timeLimitType, handleStatus]);
    return ((0, jsx_runtime_1.jsx)(attachment_video_1.default, Object.assign({}, attachment, { ref: attachmentRef, extraParams: videoExtraParams }, { children: (0, jsx_runtime_1.jsx)(curtain_1.default, { status: status, text: text, handleClick: handleCurtainClick }) })));
};
exports.default = AttachmentVideoWithTimer;
